
export const CopyRightText: React.FC = () => {
  return <p className="text-sm pt-4 text-secondary font-light">
    © The Camp Stack 2024. All Rights Reserved.
  </p>;
};
